import { useEffect } from "react";
import axios from 'axios';
import usePopupStore from "../../store/global";
import useLanguageStore from "../../store/language";

const useFetchLanguage = () =>
{
        const {popupShown }  = usePopupStore();
        const { setLanguage } = useLanguageStore();

        useEffect(()=>{
            if(!popupShown) return
            
            var userId = Readium.getUserInfo().id;
            var serviceName = "TTT";
            var ops_basepath= Config.SERVICE_BASE_PATH;
            var token = Readium.userInfo.accessToken;
            
            axios({
                // url : ops_basepath+'/user/'+userId+'/publisher/pearson/'+serviceName+'/language',
                url : ops_basepath+'/user/'+userId+'/publisher/new_hodder_pub/'+serviceName+'/language',
                method: "GET",
                headers: { 'accessToken': token, 'platform': 'WR'}
              }).then((res) => {
                if (res.data) {
                    setLanguage((state)=>({...state,language:res.data}))
                }
              });
        },[popupShown])
}
export default useFetchLanguage;